import * as React from "react";
import SimpleButton from "../../RenderComponents/SimpleButton";

interface IProps {
    hasNext: boolean;
    onNextPost: () => void;
    type?: "a" | "button";
    text?: string;
    title?: string;
    ariaLabel?: string;
    showIcon?: boolean;
}

const NextButton = (props: IProps) => {
    return (
        <SimpleButton
            className="CMS_button CMS_bSimple"
            disabled={!props.hasNext}
            type={props.type}
            title={props.title}
            ariaLabel={props.ariaLabel}
            href={"#"}
            onClick={async (e) => {
                e.preventDefault();
                await props.onNextPost();
            }}
        >
            {props.text || "Next post"} {props.showIcon ? <em className="fa fa-arrow-right" aria-hidden="true"></em> : null}
        </SimpleButton>
    );
};

export default NextButton;
